import React, { useEffect } from "react"
import { Link } from "gatsby"
import { Button } from "flowbite-react"

const pages = [
  { title: "AI, ML & Data", id: "ai-ml", href: "/technologies/ai-ml" },
  { title: "Mobile App", id: "mobile-app", href: "/technologies/mobile-app" },
  {
    title: "Backend & Database",
    id: "backend",
    href: "/technologies/backend",
  },
  {
    title: "Web Frontend",
    id: "web",
    href: "/technologies/web",
  },
  {
    title: "Cloud Services",
    id: "cloud-services",
    href: "/technologies/cloud-services",
  },
  {
    title: "Security & Compliances",
    id: "security",
    href: "/technologies/security",
  },
  {
    title: "IoT / BLE / EV",
    id: "iot",
    href: "/technologies/iot",
  },
  // {
  //   title: "No Code / CMS",
  //   id: "no-code",
  //   href: "/technologies/no-code",
  // },
]
const CommonHead = ({ activePage }) => {
  useEffect(() => {
    if (activePage) {
      const projectButton = document.getElementById(activePage)
      if (projectButton) {
        const parentContainer = projectButton.parentElement
        const scrollToPosition = projectButton.offsetLeft
        parentContainer.scrollTo({
          left: scrollToPosition,
          behavior: "smooth",
        })
      }
    }
  }, [activePage])

  return (
    <section className="flex relative pt-[7rem]  pb-[4.75rem]   box-border flex-col justify-center items-start">
      <Button.Group className="mt-8  pl-6 md:pl-20  custom-scrollbar    overflow-x-auto pb-3 w-full flex gap-3 md:gap-8 ">
        {pages.map(page => (
          <Button
            as={Link}
            key={page.id}
            id={page.id}
            className={` flex-shrink-0 focus:ring-0 duration-100 ease-in-out  w-[80px] md:w-[132px] h-[80px] md:h-[132px] md:p-1 rounded-[50%] border-blue-100 outline-none ${activePage === page.id ? " border-0" : "border"} hover:border-0 group`}
            outline
            color="custom-theme"
            theme={{
              color: {
                "custom-theme": ` hover:primary-gradient ${activePage === page.id ? "primary-gradient" : "bg-transparent"}  `,
              },
              inner: {
                base: `!px-0 !py-0 !text-sm md:!text-xl !items-center !h-full md:!py-4 !bg-transparent  ${activePage === page.id ? "!text-white-100" : "!text-blue-100"} group-hover:!text-white-100`,
              },
            }}
            to={page.href}
          >
            {page.title}
          </Button>
        ))}
      </Button.Group>
    </section>
  )
}

export default CommonHead
